import classnames from 'classnames';
import AHref from 'components/AHref';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import React from 'react';

const ActionMenu = ({
  to, icon, onClick, text, color = 'accent0', type, disabled, className, id, isLoading, badge
}) => {
  if (type === 'link') {
    return (
      <Link
        to={to}
        id={id}
        onClick={onClick}
        className={classnames('actions__option', {
          [color]: color,
          [className]: className,
          actions__option_disabled: disabled || isLoading,
          'loading' : isLoading
        })}
      >
        <span className="action-icon">
          {icon && <div className="action_icon_item">{icon}</div>}
          <div className="action-icon-text">{text}</div>
          {badge && <div className={`viso-dropdown-container__badge viso-dropdown-container__badge--${color}`}>{badge}</div>}
        </span>
      </Link>
    );
  }

  return (
    <AHref
      onClick={onClick}
      id={id}
      className={classnames('actions__option', {
        [color]: color,
        [className]: className,
        'loading' : isLoading,
        actions__option_disabled: disabled || isLoading
      })}
    >
      <span className="action-icon">
        {icon && <div className="action_icon_item">{icon}</div>}
        <div className="action-icon-text">{text}</div>
        {badge && <div className={`viso-dropdown-container__badge viso-dropdown-container__badge--${color}`}>{badge}</div>}
      </span>
    </AHref>
  );
};

ActionMenu.propTypes = {
  color: PropTypes.string,
};

export default ActionMenu;